const routes = {
  '/revenue': '',
  '/revenue/:year': 'Revenue by Source',
  '/revenue/:year/:lineNo': (url, match) => getParameterByName('lineDesc'),
  '/revenue/:year/:lineNo/:objCode': (url, match) =>
    getParameterByName('objDesc'),
  '/department': '',
  '/department/:year': 'Spending By Department',
  '/department/:year/:deptNo': (url, match) => getParameterByName('deptName'),
  '/department/:year/:deptNo/:charCode': (url, match) =>
    getParameterByName('charDesc'),
  '/department/:year/:deptNo/:charCode/:objCode': (url, match) =>
    getParameterByName('objDesc'),
  '/vendor': '',
  '/vendor/:year': 'Spending by Vendor',
  '/vendor/:year/:vendorNo': (url, match) => getParameterByName('vendorName')
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[\[\]]/g, '\\$&')
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`)
  const results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export default routes
